<template>
  <div id="app">
    <router-view/>
    <!-- <loading v-if="isLoading"/> -->
    <loading />
    <loading-mask />
  </div>
</template>

<script>
import Loading from '@/components/LoadingLogo'
import LoadingMask from '@/components/LoadingMask'
import {mapState, mapMutations} from 'vuex'
import {getHome, getAbout, getProject, getJob, getWorldView, getNews, getLive} from '@/utils/api'

export default {
  name: 'App',
  components: {
    Loading,
    LoadingMask
  },
  computed: {
    ...mapState(['isLoading'])
  },
  methods: {
    ...mapMutations([
      'setBanners',
      'setAboutUs',
      'setPartners',
      'setProducts',
      'setProjects',
      'setRoles',
      'setWorldViews',
      'setNews',
      'setLives',
      'setContactUs'
    ]),
    handleSizeChange () {
      let width = window.document.body.offsetWidth
      if (window.document.body.offsetHeight > window.screen.availHeight) {
        width = width + 17
      }
      let f = width / 96
      if (f >= 20) {
        // f = 20
      } else if (f < 13.33) {
        f = 13.33
      }
      document.querySelector('html').style.fontSize = `${f}px`
    },
    initData () {
      getHome()
        .then(r => {
          this.setBanners(r)
        })
      getAbout()
        .then(r => {
          this.setAboutUs(r.aboutUs)
          this.setPartners(r.partners)
          this.setProducts(r.product)
        })
      getProject()
        .then(r => {
          this.setProjects(r)
        })
      getJob()
        .then(r => {
          this.setContactUs(r)
        })
      getWorldView()
        .then(r => {
          let roles = r.charList.map(i => {
            i.poems = i.description.split('\r\n')
            return i
          })
          this.setRoles(roles)

          let wvs = r.worldView.map(i => {
            i.titles = i.title.split(' ')
            i.subs = i.subTitle.split(' ')
            return i
          })
          this.setWorldViews(wvs)
        })
      getNews()
        .then(r => {
          let news = r.map(i => {
            let d = new Date(i.publishtime * 1000)
            const y = d.getFullYear()
            const m = d.getMonth() + 1
            const day = d.getDate()
            i.newsDate = `${y}.${m}.${day}`
            return i
          })
          this.setNews(news)
        })
      getLive()
        .then(r => {
          this.setLives(r)
        })
    }
  },
  created () {
    this.handleSizeChange()
    window.onresize = this.handleSizeChange
    this.initData()
  }
}
</script>

<style>
html {
  font-size: 20px;
  min-width: 1280px;
  overflow-x: auto;
}

body {
  overflow-x: hidden;
  font-family: Lato,'Helvetica Neue','PingFang SC','Myriad Pro','Hiragino Sans GB','microsoft yahei' !important;
}

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td, i{
  margin: 0;
}

.bg-black{
  background-color: #000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue